import React from 'react';
import Table from '../../../shared/components/layout/Table';
import GridWrapper from '../../../shared/components/layout/GridWrapper';
import { transformData } from '../../../super-admin/utils/transformData';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const itemFormatData = ['id', 'name', 'units'];

export const ItemList = ({ itemList }) => {
  const userId = Cookies.get('userId');
  const headers = ['Item Name', 'Unit'];
  const modifiedData = itemList?.map((item) => {
    return {
      id: item.id,
      name: item.name,
      //units will comes asa array with comma seperated values so we need to join them and make it comma seperated string
      units: item.units ? item.units?.join(', ') : ''
    };
  });
  const transformedData = modifiedData?.map((item) => transformData(item, itemFormatData));

  return (
    <GridWrapper width={100}>
      <div className="table-container mt-[2rem] max-h-[calc(100vh-15rem)] overflow-auto">
        <style>{`
            .table-container .table-body {
              position: static !important;
              overflow-y: visible !important;
              max-height: none !important;
              height: auto !important;
              top: auto !important;
              padding-bottom: 0 !important;
            }
            .table-container .table-container {
              height: auto !important;
            }
            .table-container > div {
              height: auto !important;
            }
          `}</style>
        <Table headers={headers} data={transformedData} identifier={'id'} isEditEnable={false} />
      </div>
    </GridWrapper>
  );
};
